import { TextField } from "@mui/material";
import React from "react";
import { ICustomInput } from "./CustomInput";
import { customValue } from "../../../utils/colorVariable";

export const CustomMultiLineInput: React.FC<ICustomInput> = ({
  name,
  label,
  onChange,
  value,
  isDisabled,
  size = "small",
}) => {
  return (
    <TextField
      id={name}
      name={name}
      label={label}
      variant="outlined"
      color="primary"
      margin="none"
      size={size}
      fullWidth
      multiline
      rows={3}
      onChange={onChange}
      value={value}
      disabled={isDisabled}
      sx={{
        borderRadius: customValue.borderRadius,
        "& .MuiOutlinedInput-root": {
          borderRadius: customValue.borderRadius,
        },
        "& .MuiInputBase-input::placeholder": {
          fontSize: "14px",
          color: "gray",
          fontStyle: "italic",
        },
      }}
    />
  );
};
